<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="frontmatter">
<div epub:type="pagebreak" id="pagev" title="v">
<p class="ded"><a id="dedication"></a>This book is dedicated to storytellers everywhere<span epub:type="pagebreak" id="pagevi" title="vi"></span></p>
</div></section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?fd701434